export const getDensity = (isMobile, isTablet, isDesktop) => {
    if (isMobile || isDesktop) {
      return 'comfortable';
    }
    if (isTablet) {
      return 'spacious';
    }
    return 'compact';
  };
  